export enum Variant {
  DEFAULT = "default",
  FEMALE = "female",
}

export const PAGE_VARIANT: Record<Variant, string> = {
  [Variant.DEFAULT]: "generic",
  [Variant.FEMALE]: "women",
};
